import { css } from "@emotion/react";
import { theme } from "@/constants/theme";

export const cookieBannerContainer = css({
  position: "fixed",
  maxWidth: 800,
  maxHeight: 400,
  padding: 12,
  bottom: 10,
  zIndex: 20,
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
  border: "1px solid #B5B7B8",
  width: "90%",
  marginLeft: "auto",
  marginRight: "auto",
  left: "50%",
  transform: "translateX(-50%)",
});

export const linkButton = css({
  color: theme.palette.primary.main,
  textDecoration: "underline",
  fontSize: 14,
  "&:hover": {
    color: theme.palette.secondary.main,
  },
});

export const actionButton = css({
  width: "100%",
  [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
    marginTop: 16,
  },
});
